module.exports = __webpack_public_path__ + "static/media/joy-reading.9cd7a531.jpg";